export default {
  site_name: '开云体育',
  site_slogan: '感受竞技激情',
  site_description: '专业体育赛事平台',
  read_more: '阅读全文',
  view_all: '查看全部',
  back_to_home: '返回首页',
  loading: '加载中...',
  load_more: '加载更多',
  no_data: '暂无数据',
  contact_us: '联系我们',
  subscribe: '订阅资讯',
  search: '搜索',
  search_placeholder: '搜索赛事、球队、文章...',
  all_categories: '全部分类',
  popular_articles: '热门文章',
  latest_news: '最新资讯',
  related_articles: '相关文章',
  share: '分享',
  published_on: '发布于',
  updated_on: '更新于',
  read_count: '阅读量',
  breadcrumb_home: '首页',
}